<template>
  <div class="content-item">
    <img src="resources/images/under-review.png" alt="Under Review" />
    <p class="pt-5">Your request is under review!</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.content-item {
  img {
    width: 60vw;
    margin-top: 8vh;
  }
}

::v-deep #signature {
  max-width: 480px !important;
  border: solid 1px blue;
  border-radius: 5px;
}
</style>
